import React, { useState } from "react";
import styles from "./RoboticsAI.module.css";
import {
  FaRobot,
  FaArrowRight,
  FaUsers,
  FaTrophy,
  FaGraduationCap,
  FaGlobe,
  FaRocket,
  FaCity,
} from "react-icons/fa";
import roboticsleague from "../../assets/images/robotics/roboticsleague.png";
import legoleague from "../../assets/images/robotics/legoleague.png";
import IRLHero from "./IRLHero/IRLHero";
import SponsoredPartners from "./SponsoredPartners/SponsoredPartners";
import IRLInfo from "./IRLInfo/IRLInfo";
import ThemeInfo from "./ThemeInfo/ThemeInfo";
import stylesIRLHero from "./IRLHero/IRLHero.module.css";
import Categories from "./Categories/Categories";
import RegularCategory from "./RegularCategory/RegularCategory";
import OpenCategory from "./OpenCategory/OpenCategory";
import { FaUserGroup } from "react-icons/fa6";

const RoboticsAI = () => {
  const [activeCategory, setActiveCategory] = useState("regular");

  const quickStats = [
    { icon: <FaTrophy />, value: "6", label: "Seasons" },
    { icon: <FaUserGroup />, value: "10k+", label: "Participants" },
    { icon: <FaCity />, value: "15+", label: "Cities" },
    { icon: <FaRobot />, value: "2.5k+", label: "Robots Built" },
  ];

  const reasons = [
    {
      title: "Skill Development",
      description:
        "Apply critical thinking, creativity, and real-world problem-solving skills through hands-on learning experiences.",
      icon: <FaGraduationCap />,
    },
    {
      title: "Teamwork & Collaboration",
      description:
        "Enhance communication, cooperation, and resilience through team-based competitions and challenges.",
      icon: <FaUsers />,
    },
    {
      title: "Innovation & Creativity",
      description:
        "Explore new ideas, test prototypes, and iterate on solutions in a supportive environment.",
      icon: <FaRobot />,
    },
    {
      title: "Career Readiness",
      description:
        "Develop crucial skills for Industry 4.0, preparing students for future careers in AI, robotics, and technology.",
      icon: <FaTrophy />,
    },
  ];
  const handleDemoClick = () => {
    const irlHeroElement = document.querySelector(`.${stylesIRLHero.hero}`);
    irlHeroElement?.scrollIntoView({ behavior: "smooth" });
  };
  const competitions = [
    {
      title: "INDIA ROBOTICS LEAGUE AI (IRL™)",
      description:
        "A truly Indian robotics competition dedicated to science, technology, and engineering. Hosted by BHARATHI STEM TRUST & STEMx, IRL™ is a festival of competitions featuring autonomous robots, encouraging students to learn STEM and Computer Science principles through fun and engagement.",
      imagePlaceholder: roboticsleague,
    },
    {
      title: "FIRST® LEGO® League & World Robot Olympiad",
      description:
        "A global robotics program introducing STEM to children ages 4-16 through hands-on learning. Participants gain real-world problem-solving experience while building a better future together.",
      imagePlaceholder: legoleague,
    },
  ];

  return (
    <div className={styles.roboticsAI}>
      {/* Hero Section */}
      <div className={styles.heroContainer}>
        <div className={styles.hero}>
          <div className={styles.content}>
            <h1 data-aos="fade-up">
              Unleash Innovation through
              <span className={styles.highlight}>
                {" "}
                Robotics & AI Competitions
              </span>
            </h1>
            <p data-aos="fade-up" data-aos-delay="100">
              Join India's premier robotics and AI competitions to showcase your
              skills, learn from experts, and compete with the best young minds
              across the country.
            </p>
            <div
              className={styles.buttons}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <button className={styles.primary}>
                <a
                  href="https://youtu.be/Lki1oJOklXY?feature=shared"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Watch Video <FaRocket className={styles.icon} />
                </a>
              </button>
              <button className={styles.secondary} onClick={handleDemoClick}>
                <div className={styles.button_content}>
                  {" "}
                  Explore IRL <FaArrowRight className={styles.icon} />
                </div>
                <span className={styles.buttoninfo}>
                  *For Schools & Channel Partners only
                </span>
              </button>
            </div>
          </div>

          <div className={styles.statsGrid}>
            {quickStats.map((stat, index) => (
              <div key={index} className={styles.quickStat}>
                <div className={styles.statIcon}>{stat.icon}</div>
                <div className={styles.statValue}>{stat.value}</div>
                <div className={styles.statLabel}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Reasons Section */}
        <section className={styles.reasons}>
          <h2 data-aos="fade-up">
            Why Participate in{" "}
            <span className={styles.highlight}>Competitions?</span>
          </h2>
          <div className={styles.reasonsGrid}>
            {reasons.map((reason, index) => (
              <div key={index} className={styles.reasonCard}>
                <div className={styles.reasonIcon}>{reason.icon}</div>
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Competitions Section */}
        <section className={styles.competitions}>
          <h2 data-aos="fade-up">
            Our <span className={styles.highlight}>Competitions</span>
          </h2>
          <p>
            Schools can participate in national and international robotics & AI
            competitions.
          </p>
          <div className={styles.competitionsList}>
            {competitions.map((competition, index) => (
              <div key={index} className={styles.competitionCard}>
                <div className={styles.competitionImage}>
                  <img
                    src={competition.imagePlaceholder}
                    alt={competition.title}
                  />
                </div>
                <div className={styles.competitionContent}>
                  <h3>{competition.title}</h3>
                  <p>{competition.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
      <IRLHero />
      <SponsoredPartners />
      <IRLInfo />
      <ThemeInfo />
      <Categories />

      {/* Category Buttons */}
      <div className={styles.categoryButtons}>
        <button
          className={activeCategory === "regular" ? styles.active : ""}
          onClick={() => setActiveCategory("regular")}
        >
          Regular Category
        </button>
        <button
          className={activeCategory === "open" ? styles.active : ""}
          onClick={() => setActiveCategory("open")}
        >
          Open Category
        </button>
      </div>

      {/* Category Content */}
      {activeCategory === "regular" && <RegularCategory />}
      {activeCategory === "open" && <OpenCategory />}
    </div>
  );
};

export default RoboticsAI;
